/**
 * Fetch exercises from public BigQuery API (same as mobile).
 * GET .../public/exercises-catalog-v2?limit=10000&offset=0&organization_id=<organizationId>
 *
 * @param {string | null} organizationId
 * @returns {Promise<Array<{ id: string, name: string, images?: string[], videos?: string[], ... }>>}
 */
export async function fetchExercises(organizationId = null) {
  const baseUrl =
    import.meta.env.VITE_API_BASE_URL || "https://app.mighty45.com/api/v1";
  const params = new URLSearchParams({ limit: "10000", offset: "0" });
  if (organizationId) params.set("organization_id", organizationId);
  const url = `${baseUrl}/public/exercises-catalog-v2?${params.toString()}`;
  const response = await fetch(url, { headers: { "Content-Type": "application/json" } });
  if (!response.ok) {
    throw new Error(`Exercises API error: ${response.status}`);
  }
  const result = await response.json();
  const exercises = result?.data?.exercises || [];
  return exercises.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
}
